import * as actionTypes from './actionTypes';

const initialState = {
  email: null,
  isNew: null,
  isMigrated: null,
  isAvion: null,
  isEligible: null,
  isSuspended: null,
  isAddon: null,
  planDescription: null,
  token: null,
  msisdn: null,
  pid: null,
  password: null,
  checkEmailError: null,
  checkTokenError: null,
  checkPairResult: null,
  processUserResult: null,

  forgottenPassEmail: null,
  forgottenPassCheckEmailResult: null,
  forgottenPassCheckTokenResult: null,
  forgottenPassNewPassResult: null,

  changePassEmail: null,
  changePassCheckEmailResult: null,
  changePassCheckTokenResult: null,
  changePassNewPassResult: null,
};

const processReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_EMAIL:
      return {
        ...initialState,
        email: action.email,
      };
    case actionTypes.RESET_EMAIL:
      return { ...initialState };

    case actionTypes.CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        isNew: action.data && action.data.isMigrated !== true && action.data.isAvion !== true,
        isMigrated: action.data && action.data.isMigrated === true,
        isAvion: action.data && action.data.isAvion === true,
        isEligible: action.data && action.data.isEligible === true,
        isSuspended: action.data && action.data.isSuspended === true,
        isAddon:
          action.data && (action.data.isAddon === true || action.data.isAddon === false)
            ? action.data.isAddon
            : null,
        planDescription:
          action.data && action.data.description !== undefined ? action.data.description : null,
        checkEmailError: action.data.error,
      };

    case actionTypes.RESET_EMAIL_ERROR:
      return {
        ...state,
        checkEmailError: null,
      };

    case actionTypes.CREATE_TOKEN_SUCCESS:
      return {
        ...state,
        token: action.data,
      };

    case actionTypes.SET_TOKEN:
      return {
        ...initialState,
        token: action.token,
        isAddon: null,
        planDescription: null,
        msisdn: null,
        pid: null,
        password: null,
        checkPairResult: null,
        processUserResult: null,
      };

    case actionTypes.CHECK_TOKEN_SUCCESS:
      return {
        ...state,
        isNew: action.data && action.data.isNew === true,
        isEligible: action.data && action.data.isEligible === true,
        isSuspended: action.data && action.data.isSuspended === true,
        isAddon:
          action.data && (action.data.isAddon === true || action.data.isAddon === false)
            ? action.data.isAddon
            : null,
        planDescription:
          action.data && action.data.description !== undefined ? action.data.description : null,
        checkTokenError: action.data.error,
        checkEmailError: null,
        msisdn: null,
        pid: null,
        password: null,
        checkPairResult: null,
        processUserResult: null,
      };
    case actionTypes.RESET_USER_DATA:
      return {
        ...state,
        checkEmailError: null,
        checkTokenError: null,
        msisdn: null,
        pid: null,
        password: null,
        checkPairResult: null,
        processUserResult: null,
      };
    case actionTypes.SET_USER_DATA:
      return {
        ...state,
        msisdn: action.msisdn,
        pid: action.pid,
        password: action.password,
        checkPairResult: null,
        processUserResult: null,
      };
    case actionTypes.CHECK_PAIR_SUCCESS:
      return {
        ...state,
        isEligible: action.data && action.data.isEligible === true,
        isAddon:
          action.data && (action.data.isAddon === true || action.data.isAddon === false)
            ? action.data.isAddon
            : null,
        planDescription:
          action.data && action.data.description !== undefined ? action.data.description : null,
        checkPairResult: action.data,
        processUserResult: null,
      };
    case actionTypes.PROCESS_USER_SUCCESS:
      return { ...state, processUserResult: action.data };

    case actionTypes.FORGOTTEN_PASS_SET_EMAIL:
      return {
        ...state,
        forgottenPassEmail: action.email,
        forgottenPassCheckEmailResult: null,
        forgottenPassCheckTokenResult: null,
        forgottenPassNewPassResult: null,
      };

    case actionTypes.FORGOTTEN_PASS_RESET_RESULTS:
      return {
        ...state,
        forgottenPassEmail: null,
        forgottenPassCheckEmailResult: null,
        forgottenPassCheckTokenResult: null,
        forgottenPassNewPassResult: null,
      };

    case actionTypes.FORGOTTEN_PASS_CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        forgottenPassCheckEmailResult: action.data,
        forgottenPassCheckTokenResult: null,
        forgottenPassNewPassResult: null,
      };
    case actionTypes.FORGOTTEN_PASS_CHECK_TOKEN_SUCCESS:
      return {
        ...state,
        forgottenPassCheckTokenResult: action.data,
        forgottenPassNewPassResult: null,
      };
    case actionTypes.FORGOTTEN_PASS_NEW_PASS_SUCCESS:
      return {
        ...state,
        forgottenPassNewPassResult: action.data,
      };

    case actionTypes.CHANGE_PASS_SET_EMAIL:
      return {
        ...state,
        changePassEmail: action.email,
        changePassCheckEmailResult: null,
        changePassCheckTokenResult: null,
        changePassNewPassResult: null,
      };

    case actionTypes.CHANGE_PASS_RESET_RESULTS:
      return {
        ...state,
        changePassEmail: null,
        changePassCheckEmailResult: null,
        changePassCheckTokenResult: null,
        changePassNewPassResult: null,
      };

    case actionTypes.CHANGE_PASS_CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        changePassCheckEmailResult: action.data,
        changePassCheckTokenResult: null,
        changePassNewPassResult: null,
      };
    case actionTypes.CHANGE_PASS_CHECK_TOKEN_SUCCESS:
      return {
        ...state,
        changePassCheckTokenResult: action.data,
        changePassNewPassResult: null,
      };
    case actionTypes.CHANGE_PASS_NEW_PASS_SUCCESS:
      return {
        ...state,
        changePassNewPassResult: action.data,
      };

    default:
      return state;
  }
};

export default processReducer;
